module.exports = __webpack_public_path__ + "img/unit2-structural.0342d979.svg";